import React from 'react';
import IntroSection from './IntroSection';
import BenefitJobGrid from './BenefitJobGrid';

export default function JobBenefits({news}) {
    if (!news) {
        return null;
    }
    const firstNews = news[0];
    const otherNews = news.slice(1);
    return (
        <section className="job-benefit-section">
            <IntroSection item={firstNews} />
            {otherNews.length > 0 && <BenefitJobGrid items={otherNews} />}
        </section>
    );
}
